<header>
  <h1 class="modal-title">Import Sections from Form</h1>
  <button
    (click)="close()"
    aria-label="Close"
    class="modal-close"
    inlineSVG="/assets/icons/close.svg"
  ></button>
</header>

<form #form="ngForm">
  <label class="import-form">
    <span class="label-text">Provide the ID of the form to import</span>
    <mat-form-field appearance="outline" floatLabel="always">
      <input matInput type="text" [(ngModel)]="customFormId" name="custom-form-id">
    </mat-form-field>
    <button (click)="getCustomForm()" [disabled]="!validFormID">Get Form</button>
  </label>

  <label *ngIf="sections">
    Please choose the sections you wish to import into the form
    <mat-selection-list
      [(ngModel)]="sectionSelections"
      name="section-selections"
    >
      <!--
        The event prevent default is required to prevent the first selection from happening
        twice because the element is wrapped in a label – because this is our preferred style
        for markup we can get around this behavior this way.
      -->
      <mat-list-option *ngFor="let section of sections" [value]="section" (click)="$event.preventDefault()">
        {{section | formSectionName}}
      </mat-list-option>
    </mat-selection-list>
  </label>

  <div class="modal-buttons">
    <button (click)="close()" type="button">Cancel</button>
    <button (click)="importSections()" type="submit" [disabled]="saving || !sectionSelections.length">Import</button>
  </div>
</form>

<!-- Actual active logic -->
